import React from "react"
import { IoMdArrowDropdown } from "react-icons/io"
import { type Props } from "./_types"
const IconArrowDown: React.FC<Props> = ({ size = 15, color = "#fff" }): React.ReactElement => {
  return <IoMdArrowDropdown size={size} color={color} />
}

export default IconArrowDown
